// extracted by mini-css-extract-plugin
export default {"category-title":"CategoryProductCard_category-title__bjjny"};